"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batch = void 0;
const batch = ({ Items, batchSize }) => {
    /** we are choosing not to mutate Items */
    const itemsLength = Items.length;
    let iteration = 0;
    const res = [];
    do {
        const from = iteration * batchSize;
        const to = (iteration + 1) * batchSize;
        res.push(Items.slice(from, to));
        iteration++;
    } while (iteration * batchSize < itemsLength);
    return res;
};
exports.batch = batch;
